import { j as t } from "../../../jsx-runtime-B6kdoens.js";
import { c as f, f as a } from "../../../create-component-CBAeEoQ6.js";
import { Card as m } from "../index.js";
const n = f(
  "BeforeAfterCard",
  a(
    ({ children: r, ...o }, e) => /* @__PURE__ */ t.jsx(m, { ref: e, ...o, children: r })
  )
);
export {
  n as BeforeAfterCard
};
//# sourceMappingURL=index.js.map
